<template>
  <halo-dialog direction="bottom" :visible="visible" @cancel="cancel">
    <div class="hotel-dialog" :class="screen" @click="cancel">
      <div class="header-wrap">
        <img src="../images/close_icon.png" class="close-icon" />
      </div>
      <div class="hotel-list" v-if="data.length">
        <div class="hotel-item" v-for="item in data" :key="item.id" @click="select(item)">
          <div class="cover" :style="{ backgroundImage: `url(${item.cover})` }">
            <img src="../images/icon_360.png" class="icon" />
            <img v-if="item.is_has_ex" src="../images/ai_tag.png" class="ai-tag" />
          </div>
          <div class="title ellipsis">{{ item.name }}</div>
          <div class="desc ellipsis">{{ item.profile }}</div>
        </div>
      </div>
      <div class="blank-wrap" v-else>
        <img src="../images/blank.png" class="blank-icon" />
        <span>暂无其他场地</span>
      </div>
    </div>
  </halo-dialog>
</template>

<script>
import qs from '@halobear/utils/qs'
import HaloDialog from '@/components/halo-dialog'

export default {
  components: {
    HaloDialog,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    list: {
      type: Array,
      default: () => [],
    },
    screen: {
      type: String,
      default: 'vertical',
    },
  },
  computed: {
    data() {
      const id = this.$route.query.hall_id || qs.get('hall_id')
      return this.list.filter((item) => item.id != id)
    },
  },
  emits: ['cancel', 'select'],
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    select(item) {
      this.$emit('select', item)
    },
  },
}
</script>

<style lang="less" scoped>
.hotel-dialog {
  width: 100vw;
  max-height: 92vh;
  background: #ffffff;
  border-radius: 20px 20px 0px 0px;
  display: flex;
  flex-direction: column;
  // 横屏
  &.landscape {
    max-height: 50vh;
    .header-wrap {
      height: 36px;
    }
    .hotel-list {
      margin-top: -20px;
    }
    .hotel-item {
      height: 190px;
      width: 185px;
      transform: scale(0.5) translateX(-50%);
    }
  }
}
.header-wrap {
  flex-shrink: 0;
  height: 72px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  cursor: pointer;
  .close-icon {
    width: 54px;
    height: 24px;
  }
}

.hotel-list {
  display: flex;
  flex: 1;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  &::-webkit-scrollbar {
    display: none;
  }
  .hotel-item {
    height: 380px;
    width: 370px;
    text-align: center;
  }
  .cover {
    width: 370px;
    height: 246px;
    background-color: #eee;
    position: relative;
    display: block;
  }
  .icon {
    width: 64px;
    height: 64px;
    position: absolute;
    left: 12px;
    bottom: 12px;
  }
  .ai-tag {
    position: absolute;
    top: 0;
    right: 0;
    width: 92px;
    height: 30px;
  }
  .title {
    font-weight: bold;
    color: #333;
    font-size: 26px;
    padding: 20px 0 4px;
  }
  .desc {
    color: #666;
    font-weight: 400;
    font-size: 24px;
  }
}
.blank-wrap {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  color: #999;
  font-size: 30px;
  padding: 80px 0;
  .blank-icon {
    width: 330px;
    height: 330px;
    object-fit: contain;
    object-position: center center;
    margin-bottom: 60px;
  }
}
</style>
